import useApi from './useApi';

const usePackageService = () => {
  const { api } = useApi();

  // Packages managment

  const getAllPackages = () => api({
    method: 'get',
    url: '/product-marketing/v1/establishments/own/packages',
  });

  const getPackage = (packageId) => api({
    method: 'get',
    url: `/product-marketing/v1/establishments/own/packages/${packageId}`,
  });

  const postPackage = (pack) => api({
    method: 'post',
    url: '/product-marketing/v1/establishments/own/packages',
    data: pack,
  });

  const putPackage = ({ packageId, pack }) => api({
    method: 'put',
    url: `/product-marketing/v1/establishments/own/packages/${packageId}`,
    data: pack,
  });

  return {
    getAllPackages,
    getPackage,
    postPackage,
    putPackage,
  };
};

export default usePackageService;
